import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  // Ambil data produk dari localStorage
  const [products, setProducts] = useState(() => {
    const savedProducts = localStorage.getItem("products");
    return savedProducts ? JSON.parse(savedProducts) : [];
  });

  // State form
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [editingProduct, setEditingProduct] = useState(null);

  // 🌙 Dark Mode
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark";
  });

  // Simpan ke localStorage saat products atau tema berubah
  useEffect(() => {
    localStorage.setItem("products", JSON.stringify(products));
  }, [products]);

  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  // Tambah produk baru
  const handleAddProduct = (e) => {
    e.preventDefault();
    const newProduct = {
      id: Date.now(),
      name,
      price: Number(price),
      stock: Number(stock),
    };
    setProducts([...products, newProduct]);
    setName("");
    setPrice("");
    setStock("");
  };

  // Hapus produk
  const handleDelete = (id) => {
    setProducts(products.filter((p) => p.id !== id));
  };

  // Edit produk
  const handleEdit = (product) => {
    setEditingProduct(product);
    setName(product.name);
    setPrice(product.price);
    setStock(product.stock);
  };

  // Update produk
  const handleUpdate = (e) => {
    e.preventDefault();
    setProducts(
      products.map((p) =>
        p.id === editingProduct.id
          ? { ...editingProduct, name, price: Number(price), stock: Number(stock) }
          : p
      )
    );
    setEditingProduct(null);
    setName("");
    setPrice("");
    setStock("");
  };

  // Hapus semua produk
  const handleClearAll = () => {
    if (window.confirm("Hapus semua produk?")) {
      setProducts([]);
      localStorage.removeItem("products");
    }
  };

  // Hitung total stok & total nilai
  const totalStock = products.reduce((sum, p) => sum + Number(p.stock), 0);
  const totalValue = products.reduce((sum, p) => sum + Number(p.price) * Number(p.stock), 0);

  return (
    <div className={`App ${darkMode ? "dark" : ""}`}>
      <header>
        <h1>🛍️ CRUD Produk</h1>
        <button
          className="theme-toggle"
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? "☀️ Mode Terang" : "🌙 Mode Gelap"}
        </button>
      </header>

      <form onSubmit={editingProduct ? handleUpdate : handleAddProduct}>
        <input
          type="text"
          placeholder="Nama Produk"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="number"
          placeholder="Harga"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
        />
        <input
          type="number"
          placeholder="Stok"
          value={stock}
          onChange={(e) => setStock(e.target.value)}
          required
        />
        <button type="submit">
          {editingProduct ? "💾 Simpan" : "➕ Tambah"}
        </button>
        {editingProduct && (
          <button
            type="button"
            onClick={() => {
              setEditingProduct(null);
              setName("");
              setPrice("");
              setStock("");
            }}
          >
            ❌ Batal
          </button>
        )}
      </form>

      {products.length > 0 && (
        <button
          onClick={handleClearAll}
          className="clear-btn"
        >
          🗑️ Hapus Semua
        </button>
      )}

      <table>
        <thead>
          <tr>
            <th>Nama Produk</th>
            <th>Harga</th>
            <th>Stok</th>
            <th>Total</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="5">Belum ada produk</td>
            </tr>
          ) : (
            products.map((product) => (
              <tr key={product.id}>
                <td>{product.name}</td>
                <td>Rp {product.price.toLocaleString()}</td>
                <td>{product.stock}</td>
                <td>Rp {(product.price * product.stock).toLocaleString()}</td>
                <td>
                  <button onClick={() => handleEdit(product)}>✏️ Edit</button>
                  <button onClick={() => handleDelete(product.id)}>🗑️ Hapus</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {products.length > 0 && (
        <div className="summary">
          <p><strong>Total Stok:</strong> {totalStock}</p>
          <p><strong>Total Nilai Barang:</strong> Rp {totalValue.toLocaleString()}</p>
        </div>
      )}
    </div>
  );
}

export default App;
